import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Icon, { NAMES } from '@ifit/react-icons';
import { ifitBlack80 } from '../../theme/colors';

export default class MultiSelectButton extends Component {
  static propTypes = {
    id: PropTypes.number.isRequired,
    handleSelectOption: PropTypes.func.isRequired,
    optionText: PropTypes.string.isRequired,
    subtext: PropTypes.string,
    iconText: PropTypes.string,
    displayIconVersion: PropTypes.bool,
    activeOptions: PropTypes.array
  };

  selectOption = () => {
    this.props.handleSelectOption(this.props.id);
  }

  render() {
    const { activeOptions } = this.props;

    return (
      <button
        className={ classNames('select-button', {
          'icon-button': this.props.displayIconVersion,
          'subtext-included': this.props.subtext && !this.props.displayIconVersion,
          'selected': activeOptions.indexOf(this.props.id) !== -1,
          'nonselected': activeOptions.length > 0 && activeOptions.indexOf(this.props.id) === -1
        }) }
        onClick={ this.selectOption }
      >
        <span className="select-copy">
          { this.props.displayIconVersion ? this.props.iconText : this.props.optionText }
          { (this.props.subtext && !this.props.displayIconVersion) && <span className="select-subtext">{ this.props.subtext }</span> }
        </span>
        { !this.props.displayIconVersion &&
          <Icon
            name={ activeOptions.indexOf(this.props.id) !== -1 ? NAMES.LINE_CHECKBOX_CHECKED : NAMES.LINE_CHECKBOX }
            color={ ifitBlack80 }
            size={ 22 }
            unitSize="px"
          />
        }
      </button>
    );
  }
}
